import request from '../utils/http'
const appid = 5  // 不同小程序对接同一后台  5-维应生活服务开发版、2005-维应生活服务


// 修改用户信息 205
export function updateUserInfo(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "ams_shop_user_edit",
            ...data 
        }  //接口参数
    })
}

// 修改用户扩展信息 143
export function updateUserExtInfo(data) {
    return request({
        url: "/service/farming.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "ams_farming_user_ext_edit",
            ...data 
        }  //接口参数
    })
}

// 修改用户昵称头像 3
export function updateUserNickTx(data) {
    return request({
        url: "/service_app/saveuser.aspx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            appid,
            ...data
        }  //接口参数
    })
}
